export const appMode = {
  homeWorkBench: {
    // withHeader: true,
    withHeader: false,
  }
}
